export const PLACEHOLDER_IMAGE = '/images/placeholder-image.webp'
